import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";


const sliceName = "globalErrorSlice";

const initialState = {
  isGlobalError: false,
  globalErrorMsg: null
};

///////////////////////////////////////////////////////////////SINHRONE METODE

const raiseGlobalError = (state, action) => {
  state.isGlobalError = true;
  state.globalErrorMsg = action.payload.msg;
}

const resetGlobalError = (state, action) => {
  state = initialState;
}

//////////////////////////////////////////////////////////////// SLICE

const globalErrorSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {raiseGlobalError, resetGlobalError},
  extraReducers: (builder) => {},
});

export const asyncActions = {};
export const actions = globalErrorSlice.actions;
export default globalErrorSlice.reducer;
